
export enum TipoRoteiroAgendamentoEnum {
  Unico = 'Unico',
  Diario = 'Diario',
  Semanal = 'Semanal',
  Mensal = 'Mensal',
  Quinzenal = 'Quinzenal',
}
